import { useEffect, useState } from 'react';
import {
  IconExpand,
  ButtonSecondary,
  ButtonSize,
  Popup,
  InputText,
  PermissionDenied,
  PermissionEnum,
  IconLoader,
  ToggleInput,
} from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetNotificationsTemplatesQuery,
  useCreateNotificationTemplateMutation,
  useLazyGetNotificationsTemplatesTypesQuery,
} from './store/services';
import Columns from './columns';

import cn from './notification-settings.module.css';

const NotificationSettings = () => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [templateName, setTemplateName] = useState('');
  const [active, setActive] = useState(false);

  const {
    administrationDictionaries: { activePermissions },
  } = useAppSelector((state) => state);

  const [getNotificationsTemplate, { isLoading, isFetching }] =
    useLazyGetNotificationsTemplatesQuery();
  const [createTemplate, { isLoading: requestInProgress, isSuccess }] =
    useCreateNotificationTemplateMutation();
  const [getNotificationsTemplatesTypes] =
    useLazyGetNotificationsTemplatesTypesQuery();

  const onAddTemplate = async () => {
    await createTemplate({
      name: templateName,
      active,
      notificationsTypes: [],
    });
  };

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions?.includes(
        PermissionEnum.NOTIFICATIONS_TYPES_TEMPLATE_LIST,
      )
    ) {
      getNotificationsTemplate();
      getNotificationsTemplatesTypes();
    }
  }, [activePermissions]);

  useEffect(() => {
    if (isSuccess) {
      setTemplateName('');
      setPopupVisible(false);
    }
  }, [isSuccess]);

  useEffect(() => {
    let title = 'Notification Settings';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.notificationsSettingsLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_ADMINISTRATION) ||
      !activePermissions.includes(
        PermissionEnum.NOTIFICATIONS_TYPES_TEMPLATE_LIST,
      )
    ) {
      content = <PermissionDenied />;
    } else {
      let templatesContent;

      if (isLoading || isFetching) {
        templatesContent = (
          <div className={cn.templatesLoader}>
            <IconLoader />
          </div>
        );
      } else {
        templatesContent = (
          <div className={cn.columns}>
            <Columns />
          </div>
        );
      }
      content = (
        <div className={cn.notificationSettings}>
          <div className={cn.notificationSettingsHeader}>
            <div className={cn.notificationSettingsTitle}>
              Notification settings
            </div>
            {activePermissions?.includes(
              PermissionEnum.NOTIFICATIONS_TYPES_TEMPLATE_CREATE_ACTION,
            ) && (
              <ButtonSecondary
                text="Add Template"
                icon={<IconExpand />}
                size={ButtonSize.SMALL}
                onClick={() => setPopupVisible(true)}
              />
            )}
          </div>
          {templatesContent}
          <Popup
            title="Add new Notification Template"
            onCancelClick={() => {
              setPopupVisible(false);
              setTemplateName('');
            }}
            isVisible={popupVisible}
            onOkClick={onAddTemplate}
            okButtonText={requestInProgress ? 'Loading...' : 'Add Template'}
            cancelButtonText="Cancel"
            okButtonDisabled={requestInProgress}
          >
            <div className={cn.createTemplateWrapper}>
              <InputText
                name="templateName"
                value={templateName}
                placeholder="Template name..."
                onChange={(e) => setTemplateName(e.target.value)}
                labelClassName={cn.templateName}
              />
              <div className={cn.activeWrapper}>
                <ToggleInput
                  name="active"
                  title="Active"
                  checked={active}
                  onChange={(e) => setActive(e.target.checked)}
                />
              </div>
            </div>
          </Popup>
        </div>
      );
    }
  }

  return content;
};

export default NotificationSettings;
